module.exports = __webpack_public_path__ + "static/media/smile-angel.a1ea83c1.svg";